import { Outlet } from "react-router-dom"


const BeLayout = () => {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default BeLayout;
